import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function setCreditCard(params) {
    const { baseUrl, requestBrand, cardId, ...rest } = params;

    invariant(baseUrl, 'baseUrl is a required param of setCreditCard()');
    invariant(requestBrand, 'requestBrand is a required param of setCreditCard()');
    invariant(cardId, 'cardId is a required param of setCreditCard()');

    const headers = { 'Content-Type': 'application/json', 'YNAP-REQUEST-BRAND': requestBrand };
    const url = `${baseUrl}card-details`;
    const body = JSON.stringify({ cardId, ...rest });

    return labelRequest(new Request(url, { headers: new Headers(headers), method: 'POST', body }), 'setCreditCard');
}
